import { createContext, useState, useEffect } from 'react';

/* ============================================================================
   Estado da sidebar recolhida.

   Sem MUI: `useMediaQuery(theme.breakpoints.down('lg'))` foi trocado por
   `matchMedia('(max-width: 1199.95px)')` - o MESMO limite que o breakpoint `lg`
   do tema (1200px), escrito por extenso para nao depender do tema por causa de um
   numero.

   Motivo de existir o efeito: em telas pequenas a sidebar vira gaveta, e "recolhida"
   nao faz sentido - o estado precisa voltar a falso, senao o usuario que recolheu no
   desktop e depois reduziu a janela ficava com uma gaveta de 72px so com icones.
   ============================================================================ */

const initialState = {
  isCollapse: false,
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {},
  onHoverEnter: () => {},
  onHoverLeave: () => {},
};

const CollapseDrawerContext = createContext(initialState);

const CONSULTA_MOBILE = '(max-width: 1199.95px)';

function CollapseDrawerProvider({ children }) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(CONSULTA_MOBILE).matches
  );
  const [collapse, setCollapse] = useState({ click: false, hover: false });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(CONSULTA_MOBILE);
    const aoMudar = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener('change', aoMudar);
    return () => mq.removeEventListener('change', aoMudar);
  }, []);

  useEffect(() => {
    if (isMobile) setCollapse({ click: false, hover: false });
  }, [isMobile]);

  const handleToggleCollapse = () => setCollapse((c) => ({ ...c, click: !c.click }));
  const handleHoverEnter = () => setCollapse((c) => (c.click ? { ...c, hover: true } : c));
  const handleHoverLeave = () => setCollapse((c) => ({ ...c, hover: false }));

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: collapse.click && !collapse.hover,
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
